<template>
  <MlUnsupportedScreenSize v-if="showUnsupportedScreenSize" />
  <div v-else>
    <router-view />
  </div>
</template>

<script setup lang="ts">
import MlUnsupportedScreenSize from 'components/sections/layout/MlUnsupportedScreenSize.vue'

import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useNetworkStore } from 'stores/network'
import { useOnline } from '@vueuse/core'
import Notifier from 'src/services/Notifier'
import { RouteName } from 'src/models/route'
import { ConnectivityError } from 'src/models/error/errors'

const network = useNetworkStore()
const route = useRoute()
const windowWidth = ref(window.innerWidth)
const showUnsupportedScreenSize = ref(false)
const MIN_WIDTH = 250

const onResize = () => {
  windowWidth.value = window.innerWidth
  showUnsupportedScreenSize.value = windowWidth.value < MIN_WIDTH
}

onMounted(() => {
  window.addEventListener('resize', onResize)
  onResize()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

watch(
  useOnline(),
  async () => {
    await network.forceCheck()
    if (network.offlineMode) {
      Notifier.notifyError(new ConnectivityError())
    }
  },
  { immediate: true },
)

watch(
  () => network.offlineMode,
  (newValue, oldValue) => {
    // @todo: safe check on reload forever
    if (!newValue && oldValue && route.name !== RouteName.SERVICE_UNAVAILABLE) {
      location.reload()
    }
  },
  { immediate: true },
)
</script>
